<script lang="ts">
    import {EmptyCardContent, ErpDraggableDashboard, type DraggableDashboardCard} from 'src/features/erp/components';
    import type {SutorHomePageData} from '../types';
    import LinksCard from './cards/LinksCard.svelte';

    export let homepageData: SutorHomePageData;

    const cards: DraggableDashboardCard[] = [
        {
            id: 1,
            title: 'Rychlé odkazy',
            colSpan: 3,
            cardContentComponent: LinksCard,
            componentProps: {homepageData}
        },
        {
            id: 2,
            title: 'Zakázky',
            colSpan: 2,
            cardContentComponent: EmptyCardContent
        },
        {
            id: 3,
            title: 'Osobní kalendář',
            colSpan: 1,
            cardContentComponent: EmptyCardContent
        },
        {
            id: 4,
            title: 'Uživatelé Sutin 2.0',
            colSpan: 1,
            cardContentComponent: EmptyCardContent
        },
        {
            id: 5,
            title: 'Finanční toky',
            colSpan: 2,
            cardContentComponent: EmptyCardContent
        }
    ];
</script>

<ErpDraggableDashboard {cards}/>